import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { getPageRange } from '../pages/actions';
import { FileDesc } from './newFilesSlice';
import { getBlobAsync, removeExtension } from 'helpers';
import { nanoid } from 'nanoid';
import { Page } from '../pages/pagesSlice';
import groupBy from 'lodash/groupBy';

export const createdFiles: { [url: string]: File } = {};

const getOrderedId = () => `${new Date().valueOf()}_${nanoid(8)}`;

export const createNewFiles = createAsyncThunk('newFiles/create', async (_, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const modifiedPageList = await getPageRange(state);
    const hiddenPages: Page[] = [];
    const result: FileDesc[] = [];

    for (const pages of modifiedPageList) {
        const newFileDesc = (await getBlobAsync(
            pages.filter(p => !p.hidden),
            state.files
        ))!;

        if (!pages.every(page => page.hidden === true)) {
            const filename = `${removeExtension((pages[0].userFileName ?? pages[0].fileName.new ?? pages[0].fileName.old)!)}.pdf`;
            const file = new File([newFileDesc.blob], filename, { type: 'application/pdf' });
            const item: FileDesc = {
                filename,
                size: file.size,
                blobURL: window.URL.createObjectURL(file),
                details: newFileDesc.details,
                pageId: pages[0].id,
                removed: false,
                id: getOrderedId()
            };
            result.push(item);
            createdFiles[item.blobURL] = file;
        }

        hiddenPages.push(...pages.filter(p => p.hidden));
    }

    if (hiddenPages.length) {
        const hiddenPagesByFileId = groupBy(hiddenPages, p => p.sourceFileId);
        for (const sourceFileId in hiddenPagesByFileId) {
            for (const page of hiddenPagesByFileId[sourceFileId].sort(p => p.pageNr)) {
                const newFileDesc = (await getBlobAsync([page], state.files))!;

                const fileModel = state.files.entities[sourceFileId]!;
                const filename = `${fileModel.fileName.split('.').slice(0, -1).join('.')}_usunieta_${page.pageNr}.pdf`;
                const file = new File([newFileDesc.blob], filename, { type: 'application/pdf' });
                const item: FileDesc = {
                    filename,
                    size: file.size,
                    blobURL: window.URL.createObjectURL(file),
                    details: newFileDesc.details,
                    pageId: page.id,
                    removed: true,
                    id: getOrderedId()
                };

                result.push(item);

                createdFiles[item.blobURL] = file;
            }
        }
    }

    return result;
});
